document.addEventListener('DOMContentLoaded', function () {
  var atcIconHtml = (document.getElementById('tmpl-atc-icon') || {}).innerHTML || '';
  var atcSoldHtml = (document.getElementById('tmpl-atc-sold') || {}).innerHTML || '';
  var labelAdd = (document.getElementById('tmpl-atc-label-add') || {}).innerHTML || 'Add to Cart';
  var labelSold = (document.getElementById('tmpl-atc-label-sold') || {}).innerHTML || 'Sold Out';

  // ── INFINITE CAROUSEL ─────────────────────────────────────────────────
  document.querySelectorAll('[data-recomm-scroll-container]').forEach(function (container) {
    var wrapper = container.querySelector('[data-recomm-scroll-wrapper]');
    var section = container.closest('.recommended-product-section');
    var prevBtn = section && section.querySelector('[data-recomm-prev]');
    var nextBtn = section && section.querySelector('[data-recomm-next]');
    var origItems = Array.from(wrapper.querySelectorAll('[data-recomm-scroll-item]'));

    if (origItems.length === 0) return;

    // [iOS FIX 6] Stop Safari from competing for the horizontal gesture.
    // Vertical page scroll still works; horizontal is ours.
    container.style.touchAction = 'pan-y';

    function getVisible() {
      var w = window.innerWidth;
      if (w > 1200) return 4;
      if (w > 900) return 3;
      return 2;
    }

    /*
      Mobile gap: 1% of clientWidth between the 2 cards.
      JS must account for this so both cards are exactly equal width.
      Formula: (containerWidth - gap) / 2
    */
    function getItemWidth() {
      var cw = container.clientWidth;
      var vis = getVisible();
      if (window.innerWidth <= 767) {
        var gap = cw * 0.01; /* 1% gap between cards */
        return (cw - gap) / vis;
      }
      return cw / vis;
    }

    var bufferSize = 4;
    var clonesBefore = [];
    var clonesAfter = [];

    for (var i = 0; i < bufferSize; i++) {
      var cb = origItems[origItems.length - 1 - (i % origItems.length)].cloneNode(true);
      cb.setAttribute('aria-hidden', 'true');
      clonesBefore.unshift(cb);
    }
    for (var j = 0; j < bufferSize; j++) {
      var ca = origItems[j % origItems.length].cloneNode(true);
      ca.setAttribute('aria-hidden', 'true');
      clonesAfter.push(ca);
    }

    wrapper.innerHTML = '';
    clonesBefore.forEach(function (el) {
      wrapper.appendChild(el);
    });
    origItems.forEach(function (el) {
      wrapper.appendChild(el);
    });
    clonesAfter.forEach(function (el) {
      wrapper.appendChild(el);
    });

    var allItems = Array.from(wrapper.children);
    var currentIndex = clonesBefore.length;
    var isAnimating = false;

    // ── [iOS FIX 1] ANIM LOCK WITH WATCHDOG ─────────────────────────────
    // Root cause of the iPhone freeze: isAnimating was ONLY reset inside
    // `transitionend`. On iOS, that event can be silently skipped (URL-bar
    // resize, touchcancel, gesture takeover) — which left isAnimating stuck
    // at `true` and killed every subsequent arrow click / swipe for the rest
    // of the session. The timer guarantees the lock always releases.
    var animTimer = null;
    function lockAnim() {
      isAnimating = true;
      clearTimeout(animTimer);
      animTimer = setTimeout(unlockAnim, 600); // 350ms slide + safety margin
    }
    function unlockAnim() {
      clearTimeout(animTimer);
      isAnimating = false;
    }

    function setItemWidths() {
      var w = getItemWidth();
      allItems.forEach(function (el) {
        el.style.width = w + 'px';
        el.style.flexShrink = '0';
        /* 1% gap on mobile via margin-right, zero on desktop (no gap needed) */
        if (window.innerWidth <= 767) {
          el.style.marginRight = container.clientWidth * 0.01 + 'px';
        } else {
          el.style.marginRight = '0px';
        }
      });
    }

    function getStep() {
      return getItemWidth() + (window.innerWidth <= 767 ? container.clientWidth * 0.01 : 0);
    }

    // [iOS FIX 2] Force a style flush between `transition:none` and the
    // animated transform. Without this, WebKit sometimes batches both into
    // one frame — the transition never starts, so `transitionend` never fires.
    function goTo(index, animate) {
      var x = -index * getStep();
      if (animate === false) {
        wrapper.style.transition = 'none';
        wrapper.style.transform = 'translateX(' + x + 'px)';
        void wrapper.offsetHeight; // flush
      } else {
        void wrapper.offsetHeight; // flush the current (transition:none) state first
        wrapper.style.transition = 'transform 0.35s ease';
        wrapper.style.transform = 'translateX(' + x + 'px)';
      }
    }

    function normalizeLoop() {
      var realStart = clonesBefore.length;
      var realEnd = clonesBefore.length + origItems.length;
      if (currentIndex >= realEnd) {
        currentIndex = realStart + (currentIndex - realEnd);
        goTo(currentIndex, false);
      }
      if (currentIndex < realStart) {
        currentIndex = realEnd - (realStart - currentIndex);
        goTo(currentIndex, false);
      }
    }

    setItemWidths();
    goTo(currentIndex, false);

    // [iOS FIX 3] Guard the listener. iOS applies sticky :hover on tap, so the
    // 1.4s product-image transitions fire transitionend events that BUBBLE up
    // to the wrapper and used to trigger the loop-normalize logic at random.
    wrapper.addEventListener('transitionend', function (e) {
      if (e.target !== wrapper || e.propertyName !== 'transform') return;
      unlockAnim();
      normalizeLoop();
    });

    function next() {
      if (isAnimating) return;
      lockAnim();
      currentIndex++;
      goTo(currentIndex, true);
    }
    function prev() {
      if (isAnimating) return;
      lockAnim();
      currentIndex--;
      goTo(currentIndex, true);
    }

    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    var touchStartX = 0,
      touchStartY = 0,
      touchDeltaX = 0,
      isScrolling = null; // null = undecided, true = vertical, false = horizontal

    container.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchDeltaX = 0;
        isScrolling = null; // reset on every new touch
      },
      { passive: true }
    );

    container.addEventListener(
      'touchmove',
      function (e) {
        var deltaX = e.touches[0].clientX - touchStartX;
        var deltaY = e.touches[0].clientY - touchStartY;

        // First move decides the direction — lock it in
        if (isScrolling === null) {
          isScrolling = Math.abs(deltaY) > Math.abs(deltaX);
        }

        // If vertical scroll — do nothing, let the browser handle it
        if (isScrolling) return;

        touchDeltaX = deltaX;

        if (!isAnimating) {
          wrapper.style.transition = 'none';
          wrapper.style.transform = 'translateX(' + (-currentIndex * getStep() + touchDeltaX) + 'px)';
        }
      },
      { passive: true }
    );

    // [iOS FIX 4] Single exit path for both touchend AND touchcancel.
    // iOS fires touchcancel (never touchend) on rubber-band overscroll, the
    // edge back-swipe, and scroll takeover. With no handler, the wrapper was
    // left with `transition:none` + a half-dragged transform = visually stuck.
    function endSwipe(cancelled) {
      if (isScrolling || cancelled) {
        isScrolling = null;
        if (touchDeltaX !== 0) {
          unlockAnim();
          goTo(currentIndex, true); // snap back cleanly
        }
        touchDeltaX = 0;
        return;
      }

      var threshold = getItemWidth() * 0.2;
      unlockAnim();
      if (touchDeltaX < -threshold) {
        next();
      } else if (touchDeltaX > threshold) {
        prev();
      } else {
        goTo(currentIndex, true);
      }
      touchDeltaX = 0;
      isScrolling = null;
    }

    container.addEventListener('touchend', function () {
      endSwipe(false);
    });
    container.addEventListener('touchcancel', function () {
      endSwipe(true);
    });

    // [iOS FIX 5] Ignore height-only resizes. Safari fires `resize` every time
    // the URL bar collapses/expands on scroll. That landed inside the 350ms
    // slide, called goTo(..., false) → `transition:none` → cancelled the running
    // transition → no transitionend → permanent isAnimating deadlock.
    var resizeTimer;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return; // width unchanged = URL-bar event, ignore
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        unlockAnim();
        setItemWidths();
        goTo(currentIndex, false);
      }, 100);
    });

    // Extra safety: if the tab is backgrounded mid-slide, iOS suspends the
    // transition and transitionend never arrives. Release the lock on return.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && isAnimating) {
        unlockAnim();
        goTo(currentIndex, false);
        normalizeLoop();
      }
    });
  });

  // ── SHARE ─────────────────────────────────────────────────────────────
  function closeAllSharePanels() {
    document.querySelectorAll('.recomm-share-content').forEach(function (p) {
      p.style.display = 'none';
    });
  }
  document.addEventListener('click', function (e) {
    var shareBtn = e.target.closest('.recomm-share-btn');
    if (shareBtn) {
      e.stopPropagation();
      var accordion = shareBtn.closest('.share-accordion');
      if (!accordion) return;
      var content = accordion.querySelector('.recomm-share-content');
      var isOpen = content.style.display === 'block';
      closeAllSharePanels();
      content.style.display = isOpen ? 'none' : 'block';
      return;
    }
    var fbLink = e.target.closest('.recomm-share-facebook');
    if (fbLink) {
      e.preventDefault();
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(fbLink.dataset.url), '_blank');
      return;
    }
    var twLink = e.target.closest('.recomm-share-twitter');
    if (twLink) {
      e.preventDefault();
      window.open(
        'https://twitter.com/intent/tweet?url=' +
          encodeURIComponent(twLink.dataset.url) +
          '&text=' +
          encodeURIComponent(twLink.dataset.title),
        '_blank'
      );
      return;
    }
    var waLink = e.target.closest('.recomm-share-whatsapp');
    if (waLink) {
      e.preventDefault();
      window.open('https://wa.me/?text=' + encodeURIComponent(waLink.dataset.url), '_blank');
      return;
    }
    var copyLink = e.target.closest('.recomm-share-copy');
    if (copyLink) {
      e.preventDefault();
      navigator.clipboard.writeText(copyLink.dataset.url).then(function () {
        alert('Link copied!');
      });
      return;
    }
    if (!e.target.closest('.share-accordion')) closeAllSharePanels();
  });

  // ── SIZE SELECTOR ─────────────────────────────────────────────────────
  document.querySelectorAll('.size-options').forEach(function (ul) {
    var productId = ul.dataset.productId;
    var atcBtn = document.getElementById('atc-btn-' + productId);
    var atcText = document.getElementById('atc-text-' + productId);

    function setAvailable(btn, text) {
      btn.classList.remove('disable');
      btn.removeAttribute('disable');
      text.innerHTML = atcIconHtml + ' ' + labelAdd;
    }
    function setSoldOut(btn, text) {
      btn.classList.add('disable');
      btn.setAttribute('disable', 'true');
      text.innerHTML = atcSoldHtml + ' ' + labelSold;
    }

    var initialSelected = ul.querySelector('li.size-option.selected');
    if (initialSelected && atcBtn) {
      atcBtn.setAttribute('data-variant-id', initialSelected.dataset.variantId);
      if (initialSelected.dataset.available !== 'true') setSoldOut(atcBtn, atcText);
    }

    ul.addEventListener('click', function (e) {
      var li = e.target.closest('li.size-option');
      if (!li) return;
      ul.querySelectorAll('li').forEach(function (x) {
        x.classList.remove('selected');
      });
      li.classList.add('selected');
      if (atcBtn && atcText) {
        atcBtn.setAttribute('data-variant-id', li.dataset.variantId);
        if (li.dataset.available === 'true') {
          setAvailable(atcBtn, atcText);
        } else {
          setSoldOut(atcBtn, atcText);
        }
      }
    });
  });
});